// extracted by mini-css-extract-plugin
export default {"label":"DictionaryStep_label__mIzu6","container":"DictionaryStep_container__ruWXv","buttonsContainer":"DictionaryStep_buttonsContainer__GEUad"};